import React, { Fragment } from 'react';
import './App.css';
import { User } from '../model/Model';
import { AuthService } from '../services/AuthServices';
import { Login } from './Login';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { NavBar } from './Navbar';
import { Home } from './Home';
import { Profile } from './Profile';
import { Spaces } from './spaces/Spaces';
import { DataService } from '../services/DataService';

interface AppState {
  user: User | undefined;
}

const getBasename = () => {
  /* const path = window.location.pathname.split('/')[1];
  console.log('this is the pathname ' + window.location.pathname);
  console.log('this is the basename ' + path); */
  return window.location.pathname;
};

class App extends React.Component<unknown, AppState> {
  constructor(props: any) {
    super(props);
    this.state = {
      user: undefined,
    };
    this.setUser = this.setUser.bind(this); //another way to bind a function to a class
  }

  private authService: AuthService = new AuthService();
  private dataService: DataService = new DataService();

  private setUser(user: User) {
    this.setState({ user: user });
    console.log('setting the user: ' + user);
  }

  render() {
    return (
      <Fragment>
        <Router basename={getBasename()}>
          <main className="wrapper">
            <NavBar user={this.state.user} />
            <Routes>
              <Route path="/" element={<Home />}></Route>
              <Route
                path="/login"
                element={
                  <Login
                    authService={this.authService}
                    setUser={this.setUser}
                  />
                }></Route>
              <Route
                path="/profile"
                element={
                  <Profile
                    authService={this.authService}
                    user={this.state.user}
                  />
                }></Route>
              <Route
                path="/spaces"
                element={<Spaces dataService={this.dataService} />}></Route>
            </Routes>
          </main>
        </Router>
      </Fragment>
    );
  }
}

export default App;
